module.exports = __webpack_public_path__ + "static/media/homemade-03.5f630eee.webm";